import { useSelector } from "react-redux";
import { RootState } from "src/redux";
import { UserInfoClaimsI } from "src/types/User";

interface UseUserInfoReturn {
  data: UserInfoClaimsI | null;
  isLoading: boolean;
  error: Error | null;
}

/**
 * Returns the current user's identity claims, sourced from either the decoded
 * JWT (Auth0 mode) or the `/auth/userinfo` response (cookie auth mode).
 *
 * Claims live under namespaced keys like `https://www.ctmsmart.com/fullName`.
 */
export function useUserInfo(): UseUserInfoReturn {
  const { data, loading, error } = useSelector(
    (state: RootState) => state.userInfo,
  );
  return { data, isLoading: loading, error };
}
